import { Button, ErrorBoundary, Icon, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography, Color } from '@genial/design-tokens';
import { FlatList } from 'native-base';
import React from 'react';

import { useSpreadsheetRequests } from '../../hooks/spreadsheet-requests';
import { SpreadsheetRequestItem } from '../SpreadsheetRequestItem';

import { Separator } from './components/Separator';

interface SpreadsheetRequestsProps {}

export const SpreadsheetRequests: React.FC<SpreadsheetRequestsProps> = () => {
  const { updateButtonIsDisabled, data, handleRefreshSpreadsheetRequests, hasData, isLoading } =
    useSpreadsheetRequests();
  return (
    <VStack
      borderRadius={BoxRadius.sm}
      justifyContent="space-between"
      bg={Color.background}
      w="full"
      p={Spacing['stack.xxs']}
      space={Spacing['inline.xxs']}>
      <VStack space={Spacing['inline.nano']}>
        <HStack alignItems="center" justifyContent="space-between" w="full">
          <Text color="neutral.black" fontSize={Typography['fontsize.lg']} variant="semibold">
            Planilhas solicitadas
          </Text>
          <Button
            variant="textLink"
            p={0}
            onPress={handleRefreshSpreadsheetRequests}
            isDisabled={updateButtonIsDisabled}
            rightIcon={
              <Icon name="Refresh" size="xxxs" color={Color['brand.tertiary.principal']} />
            }
            _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
            Atualizar
          </Button>
        </HStack>
        <Text color="neutral.dark">
          Esta lista incluirá planilhas base e importadas. Clique em ATUALIZAR para verificar a
          disponibilidade e continuar.
        </Text>
      </VStack>
      {isLoading && <SpreadsheetRequestItem isLoading />}
      {!isLoading && hasData && (
        <FlatList
          data={data}
          renderItem={({ item }) => <SpreadsheetRequestItem {...item} />}
          maxH={{ base: '320px', sm: '500px' }}
          showsVerticalScrollIndicator={false}
          ListHeaderComponent={Separator}
          ItemSeparatorComponent={Separator}
        />
      )}
      {!isLoading && !hasData && (
        <ErrorBoundary
          errorIconOrIllustration="NotEmptyIllustration"
          errorTitle="Você ainda não enviou nenhuma solicitação"
          errorMessage="Quando fizer uma solicitação, ela aparecerá aqui para download."
        />
      )}
    </VStack>
  );
};
